import React, { useMemo, useState } from 'react';
import { FiMail, FiShield, FiUser } from 'react-icons/fi';
import Dropdown from '../components/global/Dropdown';
import { useLogout } from '../components/UserMenu';
import { useAuth } from '../context/AuthContext';
import './Profile.css';

const PROFILE_ACTIONS = [{ value: 'logout', label: 'Log out' }];

export default function Profile() {
  const { user } = useAuth();
  const handleLogout = useLogout();
  const [action, setAction] = useState('');

  const projectsLabel = useMemo(() => {
    const projects = user?.projects;
    if (!Array.isArray(projects) || projects.length === 0) return '—';
    return projects
      .map((p) => p?.name || p?.label || p?.project_name || `Project ${p?.id ?? ''}`)
      .filter(Boolean)
      .join(', ');
  }, [user?.projects]);

  const onActionChange = (next) => {
    setAction(next == null ? '' : String(next));
    if (String(next) === 'logout') {
      handleLogout();
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div>
          <h2 className="profile-title">Profile</h2>
          <p className="profile-subtitle">Your account details and session actions</p>
        </div>
        <div className="profile-actions-dropdown">
          <Dropdown
            options={PROFILE_ACTIONS}
            value={action}
            onChange={onActionChange}
            placeholder="Account actions"
            ariaLabel="Account actions"
            menuMinWidth={200}
            menuMaxWidth={260}
          />
        </div>
      </div>

      <div className="profile-card">
        <div className="profile-card-hero">
          <span className="profile-card-avatar">{user?.initials || 'AB'}</span>
          <div>
            <h3 className="profile-card-name">{user?.name || user?.username || 'User'}</h3>
            <p className="profile-card-role">{user?.role || '—'}</p>
          </div>
        </div>

        <dl className="profile-details">
          <div className="profile-detail-row">
            <dt>
              <FiUser aria-hidden />
              Username
            </dt>
            <dd>{user?.username || '—'}</dd>
          </div>
          <div className="profile-detail-row">
            <dt>
              <FiMail aria-hidden />
              Email
            </dt>
            <dd>{user?.email || '—'}</dd>
          </div>
          <div className="profile-detail-row">
            <dt>
              <FiShield aria-hidden />
              Role
            </dt>
            <dd>{user?.role || '—'}</dd>
          </div>
          <div className="profile-detail-row">
            <dt>Projects</dt>
            <dd>{projectsLabel}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
